import { Box, TextArea, FormControl } from "native-base";
import InputErrorMessage from "../inputErrorMessage";
import "./style.css";
import { useMemo } from "react";

const TextAreaField = ({
  name = "text",
  value = "",
  label = "",
  width = "auto",
  isInvalid = false,
  isDisabled = false,
  errorMessage = "Enter details",
  placeholder = "",
  onChange = () => {},
  forceRemount,
}) => {
  const formControlKey = useMemo(() => Date.now(), [forceRemount]);

  return (
    <Box>
      <FormControl
        isInvalid={isInvalid}
        isDisabled={isDisabled}
        w={width}
        key={formControlKey}
      >
        {/* {label && <FormControl.Label>{label}</FormControl.Label>} */}
        <div className={isInvalid && "text-area"}>
          <TextArea
            value={value}
            onChange={(e) => onChange(e, name)}
            h={40}
            placeholder={placeholder}
            style={{ fontSize: "14" }}
          />
        </div>
        {isInvalid && <InputErrorMessage errorMessage={errorMessage} />}
      </FormControl>
    </Box>
  );
};

export default TextAreaField;
